"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRIGGER_WIZARD = exports.SUBSCRIBE_ACTIVE_EVENT = exports.TRANSFER_NOTICE_TO_READ = exports.NOTIFICATION_STATISTICS = exports.CREATE_NOTIFICATION = exports.NOTIFICATION_LIST = exports.NOTIFICATION_PAGE = void 0;
// Message Center
exports.NOTIFICATION_PAGE = '/player/notification/page';
exports.NOTIFICATION_LIST = '/player/notification/list';
exports.CREATE_NOTIFICATION = '/player/notification/create';
exports.NOTIFICATION_STATISTICS = '/player/notification/statistics';
exports.TRANSFER_NOTICE_TO_READ = '/player/notification/read';
exports.SUBSCRIBE_ACTIVE_EVENT = '/events/active';
// Beginner's guide
exports.TRIGGER_WIZARD = '/player/activity/triggerWizard';
//# sourceMappingURL=url.notification.js.map